import { render, staticRenderFns } from "./ProductTableWidget.vue?vue&type=template&id=0b3092d9&"
import script from "./ProductTableWidget.vue?vue&type=script&lang=js&"
export * from "./ProductTableWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QTable,QInput,QSelect,QTr,QTh} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QTable,QInput,QSelect,QTr,QTh})
